export enum CommentBearing {
  AccountingDocument = 'AccountingDocument',
  DunningAction = 'DunningAction',
}